const radii = {
  none: "0",
  md: "8px",
  lg: "16px",
  xl: "20px",
  full: "9999px",
};

export default radii;
